import TabletGuard from '@/router/guards/tablet-guard'
import mobileAppGuard from '@/router/guards/mobile-app-guard'
import multiGuard from '@/router/utils/vue-router-multiguard'
import PackagePermissionsGuard from '@/router/guards/package-permissions-guard'
import { PACKAGE_PERMISSIONS } from '@/constants/features'

export default [
  {
    path: 'qr-design',
    name: 'admin:design:qr',
    beforeEnter: multiGuard([PackagePermissionsGuard]),
    meta: { packagePermissions: [PACKAGE_PERMISSIONS.QR_CUSTOMIZATION] },
    component: () => import(/* webpackChunkName: "design" */ '@/views/admin/design/qr-design/qr-themes/QrThemesList.vue'),
  },
  {
    path: 'qr-design/edit/:id?',
    alias: 'qr-design/add',
    name: 'admin:design:qr:form',
    beforeEnter: multiGuard([PackagePermissionsGuard]),
    meta: { packagePermissions: [PACKAGE_PERMISSIONS.QR_CUSTOMIZATION] },
    component: () => import(/* webpackChunkName: "design" */ '@/views/admin/design/qr-design/qr-theme-form/QrThemeFormWizard.vue'),
  },
  {
    path: 'mobile-themes',
    name: 'admin:design:mobile',
    beforeEnter: mobileAppGuard,
    component: () => import(/* webpackChunkName: "design" */ '@/views/admin/design/mobile-design/MobileThemeList.vue'),
  },
  {
    path: 'mobile-themes/edit/:id?',
    alias: 'mobile-themes/add',
    name: 'admin:design:mobile:form',
    beforeEnter: mobileAppGuard,
    component: () => import(/* webpackChunkName: "design" */ '@/views/admin/design/mobile-design/MobileThemeFormWizard.vue'),
  },
  {
    path: 'tablet-design',
    name: 'admin:design:tablet',
    beforeEnter: multiGuard([TabletGuard, PackagePermissionsGuard]),
    meta: { packagePermissions: [PACKAGE_PERMISSIONS.IPAD] },
    component: () => import(/* webpackChunkName: "design" */ '@/views/admin/design/tablet-design/tablet-themes/TabletThemesList.vue'),
  },
  {
    path: 'tablet-design/edit/:id?',
    alias: 'tablet-design/add',
    name: 'admin:design:tablet:form',
    beforeEnter: multiGuard([TabletGuard, PackagePermissionsGuard]),
    meta: { packagePermissions: [PACKAGE_PERMISSIONS.IPAD] },
    component: () => import(/* webpackChunkName: "design" */ '@/views/admin/design/tablet-design/tablet-theme-form/TabletThemeFormWizard.vue'),
  },
  {
    path: 'receipt-settings',
    name: 'admin:design:receipt-setting',
    component: () => import(/* webpackChunkName: "design" */ '@/views/admin/design/receipt-settings/ReceiptSettings.vue'),
  },
  {
    path: 'localizations',
    name: 'admin:design:localizations',
    component: () => import(/* webpackChunkName: "design-localizations" */ '@/views/admin/design/localizations/Localizations.vue'),
  },
]
